var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import { oxford, showAlert, showConfirm, showLoading } from '@/helpers';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { trans } from '@/setup/locales';
let BoxeCreator = class BoxeCreator extends Vue {
    constructor() {
        super(...arguments);
        this.currentPage = null;
        this.page = 0;
        this.start_at = 0;
        this.end_at = 0;
        this.per_page = 5;
        this.color = 'black';
        this.difference = 0;
        this.last_page_key = 0;
        this.is_last_page = false;
        this.is_last_screen = false;
        this.interval = null;
        this.clientDeliveries = [];
        this.isSpeaking = false;
        this.recipe_quality = '';
    }
    get textColor() {
        if (this.isReadonly) {
            return 'black-text';
        }
        return `${this.color}-text`;
    }
    mounted() {
        this.last_page_key = this.pages.length - 1;
        this.recipe_quality = this.recipe.quality;
        this.load(0);
    }
    cancel() {
        this.stopReading();
        this.$emit('cancel', this.recipe);
    }
    restart() {
        this.is_last_page = false;
        this.is_last_screen = false;
        this.page = 0;
        this.currentPage = null;
        this.start_at = 0;
        this.end_at = 0;
        this.color = 'black';
        this.difference = 0;
        this.load(0);
    }
    load(load_page) {
        return __awaiter(this, void 0, void 0, function* () {
            showLoading(true);
            this.stopReading();
            this.page = load_page;
            if (this.page <= this.last_page_key) {
                this.is_last_screen = false;
            }
            if (this.is_last_screen) {
                this.$emit('save', this.recipe, this.recipe_quality);
                return;
            }
            if (this.page > this.last_page_key) {
                this.is_last_screen = true;
                showLoading(false);
                return;
            }
            this.currentPage = this.pages[this.page];
            if (this.currentPage === null) {
                return;
            }
            this.per_page = this.currentPage.per_page;
            this.start_at = this.currentPage.start_at;
            this.end_at = this.currentPage.end_at;
            const clientsRecipes = this.currentPage.clientsRecipes;
            this.color = this.currentPage.color;
            this.difference = this.currentPage.difference;
            this.is_last_page = this.currentPage.is_last_page;
            const clientDeliveries = this.currentPage.deliveries.map(delivery => {
                const [recipe] = clientsRecipes.filter(client_recipe => client_recipe.recipe_id === this.recipe.id && client_recipe.client_id === delivery.client.id);
                if (typeof recipe === 'undefined') {
                    return null;
                }
                return {
                    id: delivery.id,
                    client: delivery.client.ref,
                    qty: recipe.qty,
                    position: delivery.position,
                    basket_position: delivery.basket_position,
                    require_validation: delivery.require_validation,
                    sort_name: delivery.sort_name,
                };
            })
                .filter(data => data !== null);
            this.clientDeliveries = _.sortBy(clientDeliveries, 'sort_name');
            showLoading(false);
            if (this.isSpeaking) {
                this.startReading();
            }
        });
    }
    clickedStopReading() {
        this.isSpeaking = false;
        this.stopReading();
    }
    stopReading() {
        if (this.interval !== null) {
            clearInterval(this.interval);
            window.speechSynthesis.cancel();
            this.interval = null;
        }
    }
    startReading() {
        if (!('speechSynthesis' in window)) {
            showAlert(trans('boxes.no_speech'));
            return;
        }
        const string = this.clientDeliveries
            .map(delivery => delivery.qty)
            .join(', ');
        this.isSpeaking = true;
        this.interval = this.read(() => {
            const utter = new SpeechSynthesisUtterance(string);
            const [voice] = window.speechSynthesis
                .getVoices()
                .filter(voice => ['fr-FR', 'fr-BE'].includes(voice.lang));
            utter.voice = voice;
            window.speechSynthesis.speak(utter);
        }, 6);
    }
    read(fn, interval) {
        fn();
        return window.setInterval(fn, interval * 1000);
    }
    nextPage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isReadonly) {
                this.load(this.page + 1);
                return;
            }
            const clientVerification = oxford(this.clientDeliveries
                .filter(client => client.require_validation)
                .map(client => client.client), ', ', ` ${trans('terms.and')} `);
            if (clientVerification !== '') {
                const confirm = yield showConfirm(trans('boxes.confirm_box_client', { client: clientVerification }));
                if (!confirm) {
                    return;
                }
            }
            if (this.recipe.box_validation) {
                const confirm = yield showConfirm(trans('boxes.confirm_box'));
                if (!confirm) {
                    return;
                }
            }
            this.load(this.page + 1);
        });
    }
    previousPage() {
        this.load(this.page - 1);
    }
};
__decorate([
    Prop()
], BoxeCreator.prototype, "date", void 0);
__decorate([
    Prop()
], BoxeCreator.prototype, "recipe", void 0);
__decorate([
    Prop()
], BoxeCreator.prototype, "pages", void 0);
__decorate([
    Prop({ default: false })
], BoxeCreator.prototype, "isReadonly", void 0);
BoxeCreator = __decorate([
    Component
], BoxeCreator);
export default BoxeCreator;
